<template>
  <OmtStickedModal
    @close="$emit('close')"
    :headerBind="{
      padding: ['16px', '82px 42px 0px 42px']
    }"
    :bodyBind="{
      padding: ['16px 16px 24px 16px', '68px 42px 24px 42px']
    }"
  >
    <template #header>
      <OmtButton class="clear" :display="['block', 'none']" variant="ghost" @click="clean" height="18px" p="0">
        <OmtTypography as="h3-bold" h="18px" w="46px" position="relative" :opacity="hasActive ? '1' : '0.6'">
          Limpar
        </OmtTypography>
      </OmtButton>
    </template>

    <CBox :minHeight="['initial', 'calc(100vh - 400px)']">
      <CFlex justifyContent="space-between" :mb="['24px', '36px']">
        <OmtTypography as="h1-bold"> {{ title }} </OmtTypography>
        <OmtButton class="clear" variant="ghost" @click="clean" height="18px" p="0" :display="['none', 'block']">
          <OmtTypography as="p1" classh3-bold h="18px" w="46px" position="relative" :opacity="hasActive ? '1' : '0.6'">
            Limpar
          </OmtTypography>
        </OmtButton>
      </CFlex>

      <CStack>
        <OmtCheckbox
          v-for="(optin, index) in internalOptions"
          :key="index + optin.label"
          @change="optin.isActive = !optin.isActive"
          :is-checked="optin.isActive"
          isFullWidth
        >
          <OmtTypography as="p1"> {{ optin.label }} </OmtTypography>
        </OmtCheckbox>
      </CStack>
    </CBox>

    <template #footer>
      <OmtButton w="100%" :disabled="!hasActive" @click="onSave"> Aplicar </OmtButton>
    </template>
  </OmtStickedModal>
</template>

<script>
import _ from "lodash";

/**
 * @type { Options: { label: string, isActive: Boolean } }
 *
 * @prop { Options[] } options
 */
export default {
  props: {
    title: String,
    options: Array
  },
  data() {
    return {
      isOpen: false,
      internalOptions: []
    };
  },
  mounted() {
    this.internalOptions = _.cloneDeep(this.options);
  },
  methods: {
    clean() {
      this.internalOptions.forEach(option => {
        option.isActive = false;
      });
    },
    onSave() {
      this.$emit("close");
      this.$emit("save", this.internalOptions);
    }
  },
  computed: {
    hasActive() {
      if (!this.internalOptions?.length) return false;
      return this.internalOptions.some(option => option.isActive);
    }
  }
};
</script>

<style scoped>
div[data-chakra-component="CStack"] {
  gap: 24px;
}

label[data-chakra-component="CCheckbox"] {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

label[data-chakra-component="CCheckbox"] ::v-deep div[data-chakra-component="CBox"] {
  margin-left: 0;
}
</style>
